import { render, staticRenderFns } from "./GLayoutBoxGroup.vue?vue&type=template&id=0ea9324f&scoped=true&"
import script from "./GLayoutBoxGroup.vue?vue&type=script&lang=ts&"
export * from "./GLayoutBoxGroup.vue?vue&type=script&lang=ts&"
import style0 from "./GLayoutBoxGroup.vue?vue&type=style&index=0&id=0ea9324f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea9324f",
  null
  
)

export default component.exports